<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Engineering Science"
                   :links="[{title:'Home', url:'/'},{title:'Computer Engineering'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="8"></sidebar>
        </section>
        <section class="content">
          <div class="heading-black1">Result Analysis</div>
          <tab-view>
            <tab-panel>
              <template #header>
                <i class="pi pi-sort-amount-up-alt mr-2"></i>
                <span>Result Analysis</span>
              </template>
              <div class="card p-d-flex p-jc-center">
                <Chart type="bar" :data="year19" class="w-9/12"/>
              </div>
            </tab-panel>
          </tab-view>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>

import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/academics/science/Sidebar";
import KeyRecruiters from "@/components/KeyRecruiters";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import Chart from 'primevue/chart';

export default {
  name: "ResultAnalysis",
  components: {
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    KeyRecruiters,
    TabView,
    TabPanel,
    Chart
  },
  data() {
    return {
      year19: {
        labels: ['2020-21', '2019-20', '2018-19', '2017-18', '2016-17'],
        datasets: [
          {
            label: 'Result in Percentage',
            data: [100, 99.05, 79.42, 69.82, 47.19],
            backgroundColor: ['orange','blue','red','green','purple'],
            maxBarThickness:50,
            is3D:true,
          },
        ],
      },
    }
  },

}
</script>
<style lang="scss" scoped/>